module.exports = __webpack_public_path__ + "static/media/improve_prodvty.8ab02335.svg";